// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5686":"25e3bfe0","5863":"25e3bfe0","7580":"922c34b8","8623":"bc2e634f","8977":"dc65ba47"}[chunkId] + ".chunk.css";
};